// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
const CONST_THEME_NAME = 'themeName';
const CONST_VIEWED_NEWS = 'viewedNews';
const CONST_LAST_CONNECTION_NAME = 'lastConnectionName';
const CONST_TOKEN_FOR_PORTFOLIO = 'TokenForPortfolio';
const CONST_LOCAL_STORAGE_SELECTED_CARD = 'notifPanelSelCardID';
const CONST_LANGUAGE = 'language';
const CONST_CONNECTION_SETTINGS = 'cs';
const CONST_WEB_MOBILE_WATCHLIST_NAME = 'webMobileWatchlistName';
const CONST_WEB_MOBILE_SELECTED_ACCOUNT = 'webMobileSelectedAccount';
const CONST_WEB_MOBILE_SELECTED_CHART_PERIOD = 'webMobileSelectedChartPeriod';
const CONST_WEB_MOBILE_CHART_SETTINGS = 'webMobileChartSettings';
const CONST_WEB_MOBILE_SELECTED_CHART_STYLE = 'webMobileSelectedChartStyle';
const CONST_WEB_MOBILE_CHART_INDICATORS_SETTINGS = 'webMobileChartIndicatorsSavedSettings';
const CONST_WEB_MOBILE_INDICIES_ACTIVE_HISTORY_PERIOD = 'webMobileIndiciesActiveHistoryPeriod';

class _LocalStorage
{
    constructor()
    {
        this.credentialsStorage = {};
    }

    getThemeName ()
    {
        return localStorage.getItem(CONST_THEME_NAME);
    }

    setThemeName (themeName)
    {
        localStorage.setItem(CONST_THEME_NAME, themeName);
    }

    getViewedNews ()
    {
        return localStorage.getItem(CONST_VIEWED_NEWS);
    }

    setViewedNews (jsonViewedNews)
    {
        localStorage.setItem(CONST_VIEWED_NEWS, jsonViewedNews)
    }

    getLastConnectionName ()
    {
        return localStorage.getItem(CONST_LAST_CONNECTION_NAME);
    }

    setLastConnectionName (connectionName)
    {
        localStorage.setItem(CONST_LAST_CONNECTION_NAME, connectionName)
    }

    setTokenForPortfolio (token)
    {
        localStorage.setItem(CONST_TOKEN_FOR_PORTFOLIO, token);
    }

    getTokenForPortfolio ()
    {
        return localStorage.getItem(CONST_TOKEN_FOR_PORTFOLIO);
    }

    removeTokenForPortfolio ()
    {
        localStorage.removeItem(CONST_TOKEN_FOR_PORTFOLIO);
    }

    getNotificationPanelSelectedCards ()
    {
        return localStorage.getItem(CONST_LOCAL_STORAGE_SELECTED_CARD);
    }

    setNotificationPanelSelectedCards (selectedId)
    {
        localStorage.setItem(CONST_LOCAL_STORAGE_SELECTED_CARD, selectedId)
    }

    getLanguage ()
    {
        return localStorage.getItem(CONST_LANGUAGE);
    }

    setLanguage (language)
    {
        localStorage.setItem(CONST_LANGUAGE, language);
    }

    getSelectedWebMobileWatchlistName ()
    {
        return localStorage.getItem(CONST_WEB_MOBILE_WATCHLIST_NAME);
    }

    setSelectedWebMobileWatchlistName (watchlistName)
    {
        localStorage.setItem(CONST_WEB_MOBILE_WATCHLIST_NAME, watchlistName);
    }

    getSelectedWebMobileAccount ()
    {
        return localStorage.getItem(CONST_WEB_MOBILE_SELECTED_ACCOUNT);
    }

    setSelectedWebMobileAccount (accountName)
    {
        localStorage.setItem(CONST_WEB_MOBILE_SELECTED_ACCOUNT, accountName);
    }

    getSelectedWebMobileChartPeriod ()
    {
        return localStorage.getItem(CONST_WEB_MOBILE_SELECTED_CHART_PERIOD);
    }

    setSelectedWebMobileChartPeriod (period)
    {
        localStorage.setItem(CONST_WEB_MOBILE_SELECTED_CHART_PERIOD, period);
    }

    getSelectedWebMobileChartStyle ()
    {
        return localStorage.getItem(CONST_WEB_MOBILE_SELECTED_CHART_STYLE);
    }

    setSelectedWebMobileChartStyle (style)
    {
        localStorage.setItem(CONST_WEB_MOBILE_SELECTED_CHART_STYLE, style);
    }

    getWebMobileChartSettings ()
    {
        return localStorage.getItem(CONST_WEB_MOBILE_CHART_SETTINGS);
    }

    setWebMobileChartSettings (settings)
    {
        localStorage.setItem(CONST_WEB_MOBILE_CHART_SETTINGS, settings);
    }

    getWebMobileChartIndicatorsSettings ()
    {
        return localStorage.getItem(CONST_WEB_MOBILE_CHART_INDICATORS_SETTINGS);
    }

    setWebMobileChartIndicatorsSettings (settings)
    {
        localStorage.setItem(CONST_WEB_MOBILE_CHART_INDICATORS_SETTINGS, settings);
    }

    getWebMobileIndiciesActiveHistoryPeriod ()
    {
        return localStorage.getItem(CONST_WEB_MOBILE_INDICIES_ACTIVE_HISTORY_PERIOD);
    }

    setWebMobileIndiciesActiveHistoryPeriod (historyPeriod)
    {
        localStorage.setItem(CONST_WEB_MOBILE_INDICIES_ACTIVE_HISTORY_PERIOD, historyPeriod);
    }

    setConnectionSettings (connectionName, login, customerNo)
    {
        let objTsave = {}
        if (login)
            objTsave.u = login;
        if (customerNo)
            objTsave.cN = customerNo;

        this.credentialsStorage[connectionName] = objTsave;
        localStorage.setItem(CONST_CONNECTION_SETTINGS, JSON.stringify(this.credentialsStorage));
    }

    getConnectionSettings (name)
    {
        let c = this.credentialsStorage[name];
        if (c)
        {
            return [c.u, c.cN]
        }
        return ["", ""];
    }

    loadConnectionSettings ()
    {
        try
        {
            let cs = localStorage.getItem(CONST_CONNECTION_SETTINGS)
            if (!cs)
            {
                let lcn = localStorage.getItem(CONST_LAST_CONNECTION_NAME)
                if (lcn)
                {
                    let u = localStorage.getItem('user') || '';
                    let cN = localStorage.getItem('customerNo') || '';
                    let nD = {}
                    let objts = { u: u }
                    if (cN)
                        objts.cN = cn;
                    nD[lcn] = objts
                    this.credentialsStorage = nD;
                }
                localStorage.removeItem('user');
                localStorage.removeItem('customerNo');
                localStorage.setItem('cs', JSON.stringify(this.credentialsStorage));
            }
            else
                this.credentialsStorage = JSON.parse(cs)

            localStorage.removeItem('pwd', '');
            localStorage.removeItem('savePass', 'false');
        }
        catch (ex)
        {

        }
    }
}

export let LocalStorage = new _LocalStorage();